<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<!-- 품번 -->
				<!-- <el-col :span="3">
					<search-input :label="getMessage_('QWCC001140')" paramKey="partNo" @commInput="setSearchParam" :propData="searchParams.partNo" />
				</el-col> -->
				<!--판매월-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001561')"
						paramKey="srchMm01"
						:options="srchMm01List"
						:propData="searchParams.srchMm01"
						@commChange="setSearchParam"
						:showAll="false"
					></select-combo>
				</el-col>
				<!--판매월-->
				<el-col :span="5">
					<sf-group-wrapper :label="getMessage_('\u00A0')">
						<el-date-picker
							v-model="searchDate1"
							@change="changeSearchSrchMm01"
							type="monthrange"
							align="right"
							:start-placeholder="getMessage_('QWCC000920')"
							:end-placeholder="getMessage_('QWCC000954')"
							range-separator="~"
							format="yyyy-MM"
							style="height: 38px"
						/>
					</sf-group-wrapper>
				</el-col>
				<!-- 업체 -->
				<!-- <el-col :span="3">
					<search-input :label="getMessage_('업체')" paramKey="partNo" @commInput="setSearchParam" :propData="searchParams.partNo" />
				</el-col> -->
				<!--지수구분-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001563')"
						paramKey="idxScn"
						:options="idxScnList"
						:propData="searchParams.idxScn"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!--클레임타입-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001566')"
						paramKey="ctype"
						:options="ctypeList"
						:propData="searchParams.ctype"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!--차량구분-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001015')"
						paramKey="carScn"
						:options="carScnList"
						:propData="searchParams.carScn"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<!--조건월-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001562')"
						paramKey="srchMm02"
						:options="srchMm02List"
						:propData="searchParams.srchMm02"
						@commChange="setSearchParam"
						:showAll="false"
					></select-combo>
				</el-col>
				<!--조건월-->
				<el-col :span="5">
					<sf-group-wrapper :label="getMessage_('\u00A0')">
						<el-date-picker
							v-model="searchDate2"
							@change="changeSearchSrchMm02"
							type="monthrange"
							align="right"
							:start-placeholder="getMessage_('QWCC000920')"
							:end-placeholder="getMessage_('QWCC000954')"
							range-separator="~"
							format="yyyy-MM"
							style="height: 38px"
						/>
					</sf-group-wrapper>
				</el-col>
				<!--생산공장-->
				<!-- <el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001540')"
						paramKey="plntCd"
						:options="plntCdList"
						:propData="searchParams.plntCd"
						@commChange="setSearchParam"
						:showAll="false"
					></select-combo>
				</el-col> -->
				<!--승상구분-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001017')"
						paramKey="pacScn"
						:options="pacScnList"
						:propData="searchParams.pacScn"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001021')"
						paramKey="flclSpc"
						:options="flclSpcList"
						:propData="searchParams.flclSpc"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<!--현상코드-->
				<el-col :span="4">
					<select-combo
						:label="getMessage_('QWCC001055')"
						paramKey="phmnCd"
						:options="phmnCdList"
						:propData="searchParams.phmnCd"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!-- 작업코드 
				<el-col :span="4">
					<select-combo
						:label="getMessage_('QWCC001596')"
						paramKey="opCd"
						:options="opCdList"
						:propData="searchParams.opCd"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				-->
				<!--생산법인-->
				<!-- <el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001546')"
						paramKey="customPrCor"
						:options="customPrCorList"
						:propData="searchParams.customPrCor"
						@commChange="setSearchParam"
						:showAll="false"
					></select-combo>
				</el-col> -->
				<!--판매국가-->
				<!-- <el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001542')"
						paramKey="saleNat"
						:options="saleNatList"
						:propData="searchParams.saleNat"
						@commChange="setSearchParam"
					></select-combo>
				</el-col> -->
				<!--판매지역-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001019')"
						paramKey="occuRegn"
						:options="occuRegnList"
						:propData="searchParams.occuRegn"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!--사용기간-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001053')"
						paramKey="useTerm"
						:options="useTermList"
						:propData="searchParams.useTerm"
						@commChange="setUseTerm"
					></select-combo>
				</el-col>
				<!--차량유형-->
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC001016')"
						paramKey="carTypeNm"
						:propData="searchParams.carTypeNm"
						@commInput="setSearchParam"
					/>
				</el-col>
				<!--누적-->
				<el-col :span="3">
					<sf-group-wrapper :label="getMessage_('\u00A0')">
						<el-checkbox @input="value => onCheck('check', value)">{{ getMessage_('QWCC001565') }}</el-checkbox>
					</sf-group-wrapper>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/clma/PcPcm/store/helpers';
import SelectCombo from '@qms/Components/SelectCombo';
import SearchInput from '@qms/Components/SearchInput';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		let fromDate = this.$moment().startOf('year').format('YYYY-MM-DD');
		let toDate = this.$moment().startOf('month').format('YYYY-MM-DD');
		return {
			searchDate1: [new Date(fromDate), new Date(toDate)],
			searchDate2: [new Date(fromDate), new Date(toDate)],
			fromDate: fromDate,
			toDate: toDate
		};
	},
	components: {
		SelectCombo,
		SearchInput
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		setSearchParam(param) {
			this.setSearchParam_(param);
		},
		setUseTerm(param) {
			//this.setSearchParam_({ key: 'useTerm', value: null });
			this.setSearchParam_(param);
		},
		searchList() {
			if (this.searchDate1 === null || this.searchDate2 === null) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000008'),
					message: this.getMessage_('QWCC001682')
				}); //필수 검색 값을 확인해주십시오
			} else {
				this.$sf_toggleLoading(true);
				this.getgrdList_()
					.catch(error => {
						this.$sf_toast({
							type: 'error',
							message: error.message
						});
					})
					.finally(() => {
						this.setState_({ key: 'isLoading1', value: true });
						this.$sf_toggleLoading(false);
					});
			}
		},
		onCheck(key, value) {
			if (value) this.setSearchParam_({ key, value: 'Y' });
			else this.setSearchParam_({ key, value: 'N' });
		},
		changeSearchSrchMm01(data) {
			if (data === null || data === '') {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000008'),
					message: this.getMessage_('QWCC001622')
				}); //필수 검색 값입니다.
			} else {
				let from = this.$moment(data[0]).format('YYYY-MM-DD');
				let to = this.$moment(data[1]).format('YYYY-MM-DD');
				let today = this.$moment().startOf('month').format('YYYY-MM-DD');
				let diffMonth = this.$moment(today).diff(this.$moment(to), 'months');
				if (diffMonth < 0) {
					this.$sf_showMessage({
						icon: 'error',
						title: this.getMessage_('SWCC000008'),
						message: this.getMessage_('QWCC001678')
					}); //이번달까지 선택 가능합니다.
					this.searchDate1[0] = this.fromDate;
					this.searchDate1[1] = this.toDate;
				} else {
					this.selectDate1({ from, to });
				}
			}
		},
		changeSearchSrchMm02(data) {
			if (!data) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000008'),
					message: this.getMessage_('QWCC001622')
				});
			} else {
				let from = this.$moment(data[0]).format('YYYY-MM-DD');
				let to = this.$moment(data[1]).format('YYYY-MM-DD');
				let today = this.$moment().startOf('month').format('YYYY-MM-DD');
				let diffMonth = this.$moment(today).diff(this.$moment(to), 'months');
				if (diffMonth < 0) {
					this.$sf_showMessage({
						icon: 'error',
						title: this.getMessage_('SWCC000008'),
						message: this.getMessage_('QWCC001678')
					}); //이번달까지 선택 가능합니다.
					this.searchDate2[0] = this.fromDate;
					this.searchDate2[1] = this.toDate;
				} else {
					this.selectDate2({ from, to });
				}
			}
		}
	},
	async created() {
		try {
			await this.$sf_toggleLoading(true);
			await this.postSearchSelectList_();
			await this.$sf_toggleLoading(false);
			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	}
};
</script>

<style></style>
